import { useEnumStrings } from "../../enumStrings";

import { DiscountReturn } from "../../../graphql/types";
type OfferedToDiscount = Pick<DiscountReturn, "isPrivate" | "memberOnly" | "isAvailableToAllMembers">;

// Create a custom hook for the translated text
export const useGetOfferedToText = () => {
  const enumStrings = useEnumStrings();
  
  return (discount: OfferedToDiscount, isChamberMemberAdmin?: boolean) => {
    if (discount.isPrivate) {
      return isChamberMemberAdmin
        ? enumStrings.discountText.radioGroupText.private
        : enumStrings.rootChamberAdmin.memberCompanyEmployees;
    } else if (!discount.memberOnly) {
      return enumStrings.rootChamberAdmin.anyone;
    } else if (discount.memberOnly && !discount.isAvailableToAllMembers) {
      return enumStrings.rootChamberAdmin.localMembersOnly;
    } else if (discount.memberOnly && discount.isAvailableToAllMembers) {
      return enumStrings.rootChamberAdmin.allMember;
    }
    
    return "";
  };
};